import React, { useState } from 'react';
import { Download, CalendarDays, MapPin, Clock, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function LiveAcademicHub() {
  const [activeTab, setActiveTab] = useState('All');
  const tabs = ['All', 'Academic', 'Admissions', 'Research Seminars'];
  const notices = [{
    id: 1,
    category: 'Admissions',
    title: 'Online Add/Drop of Courses for Summer Semester 2026',
    date: 'May 15, 2026',
    color: 'bg-green-50 text-green-700 border-green-200'
  }, {
    id: 2,
    category: 'Research Seminars',
    title: '131st Research Seminar of EWUCRT: AI in Healthcare',
    date: 'May 18, 2026',
    color: 'bg-teal/10 text-teal border-teal/30'
  }, {
    id: 3,
    category: 'Academic',
    title: 'Final Examination Schedule for Spring 2026 Published',
    date: 'May 10, 2026',
    color: 'bg-red-50 text-red-700 border-red-200'
  }, {
    id: 4,
    category: 'Academic',
    title: 'Guidelines for Undergraduate Thesis Submission',
    date: 'May 08, 2026',
    color: 'bg-blue-50 text-blue-700 border-blue-200'
  }];
  const filteredNotices = activeTab === 'All' ? notices : notices.filter(n => n.category === activeTab);
  const events = [{
    id: 1,
    day: '24',
    month: 'MAY',
    title: 'EWU Job Fair 2025',
    time: '10:00 AM - 4:00 PM',
    venue: 'EWU Courtyard'
  }, {
    id: 2,
    day: '28',
    month: 'MAY',
    title: 'Stress Management Workshop',
    time: '2:30 PM - 4:30 PM',
    venue: 'S. M. Nousher Ali Gallery'
  }, {
    id: 3,
    day: '05',
    month: 'JUN',
    title: 'Inter-University Tech Fest',
    time: '9:00 AM - 6:00 PM',
    venue: 'Faculty Lounge'
  }];
  return <section className="py-24 max-w-7xl mx-auto px-6 bg-white" data-id="element-302">
      <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-303">
        <div data-id="element-304">
          <h2 className="text-3xl font-bold tracking-tight mb-2 text-navy" data-id="element-305">
            Live Academic Hub
          </h2>
          <p className="text-slate-600" data-id="element-306">
            Stay updated with the latest notices and campus events.
          </p>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-8" data-id="element-307">
        {/* Left Column - Notices (70%) */}
        <div className="lg:w-[70%] flex flex-col" data-id="element-308">
          {/* Tabs */}
          <div className="flex overflow-x-auto pb-4 mb-4 hide-scrollbar space-x-2" data-id="element-309">
            {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${activeTab === tab ? 'bg-navy text-white shadow-sm' : 'bg-slate-100 text-slate-600 border border-slate-200 hover:bg-slate-200'}`} data-id="element-310">
                {tab}
              </button>)}
          </div>

          {/* Notice List */}
          <div className="bg-white border border-slate-200 shadow-sm rounded-2xl overflow-hidden flex-grow" data-id="element-311">
            <div className="divide-y divide-slate-200" data-id="element-312">
              {filteredNotices.map((notice, i) => <motion.div initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.3,
              delay: i * 0.05
            }} key={notice.id} className="p-5 hover:bg-slate-50 transition-colors group flex items-center justify-between" data-id="element-313">
                  <div className="flex-grow pr-4" data-id="element-314">
                    <div className="flex items-center space-x-3 mb-2" data-id="element-315">
                      <span className={`text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md border ${notice.color}`} data-id="element-316">
                        {notice.category}
                      </span>
                      <span className="text-xs text-slate-500" data-id="element-317">
                        {notice.date}
                      </span>
                    </div>
                    <h3 className="text-lg font-semibold text-slate-800 group-hover:text-navy transition-colors leading-snug" data-id="element-318">
                      {notice.title}
                    </h3>
                  </div>
                  <button className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-500 hover:text-white hover:bg-navy hover:border-navy transition-all shrink-0" data-id="element-319">
                    <Download className="w-4 h-4" data-id="element-320" />
                  </button>
                </motion.div>)}
            </div>
            <div className="p-4 border-t border-slate-200 bg-slate-50 flex justify-center" data-id="element-321">
              <button className="text-sm font-medium text-navy hover:text-gold transition-colors flex items-center" data-id="element-322">
                View All Notices <ArrowRight className="w-4 h-4 ml-1" data-id="element-323" />
              </button>
            </div>
          </div>
        </div>

        {/* Right Column - Events (30%) */}
        <div className="lg:w-[30%] flex flex-col" data-id="element-324">
          <div className="flex items-center space-x-2 mb-6 px-2" data-id="element-325">
            <CalendarDays className="w-5 h-5 text-gold" data-id="element-326" />
            <h3 className="text-xl font-bold text-slate-900" data-id="element-327">
              Upcoming Events
            </h3>
          </div>

          <div className="space-y-4 flex-grow" data-id="element-328">
            {events.map((event, i) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: i * 0.1
          }} key={event.id} className="bg-white border border-slate-200 shadow-sm rounded-xl p-4 flex space-x-4 group hover:border-slate-300 hover:shadow-md transition-all cursor-pointer" data-id="element-329">
                {/* Date Block */}
                <div className="flex flex-col items-center justify-center w-16 h-16 rounded-lg bg-navy shrink-0 transition-colors" data-id="element-330">
                  <span className="text-2xl font-extrabold text-gold leading-none" data-id="element-331">
                    {event.day}
                  </span>
                  <span className="text-[10px] font-bold text-white/70 tracking-widest mt-1" data-id="element-332">
                    {event.month}
                  </span>
                </div>

                {/* Event Details */}
                <div className="flex flex-col justify-center" data-id="element-333">
                  <h4 className="font-semibold text-slate-900 group-hover:text-navy leading-tight mb-2" data-id="element-334">
                    {event.title}
                  </h4>
                  <div className="space-y-1" data-id="element-335">
                    <div className="flex items-center text-xs text-slate-500" data-id="element-336">
                      <Clock className="w-3 h-3 mr-1.5" data-id="element-337" /> {event.time}
                    </div>
                    <div className="flex items-center text-xs text-slate-500" data-id="element-338">
                      <MapPin className="w-3 h-3 mr-1.5" data-id="element-339" /> {event.venue}
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <button className="mt-4 w-full py-3 rounded-xl border border-slate-200 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-340">
            View Full Calendar
          </button>
        </div>
      </div>
    </section>;
}